import { GridColumnType } from "components/grid";
import { RequestAction } from "store/entities/actions";
import { ALL_TEAMS_ID, TEAM, TeamAction } from "store/entities/teams";
import { IActionWithPayload } from "store/helper";

import { SettingsViewAction, SettingsViewActionsNames } from "./actions";
import { ISetFocusedColumnPayload, ISetTeamPayload } from "./interfaces";

export interface ISettingsViewState {
  teamId: string;
  focusedColumn: GridColumnType;
  isUpdatingTeamNotifications: boolean;
  nextForwardingAddress: string;
  isDomainAdded: boolean;
}

const initialState: ISettingsViewState = {
  teamId: ALL_TEAMS_ID,
  focusedColumn: GridColumnType.Second,
  isUpdatingTeamNotifications: false,
  // @ts-expect-error TS(2322): Type 'null' is not assignable to type 'string'.
  nextForwardingAddress: null,
  isDomainAdded: false,
};

export function settingsViewReducer(
  state: ISettingsViewState = initialState,
  action: SettingsViewAction | TeamAction
): ISettingsViewState {
  switch (action.type) {
    case SettingsViewActionsNames.SET_TEAM_ID: {
      const { payload } = action as IActionWithPayload<string, ISetTeamPayload>;
      return { ...state, teamId: payload.teamId };
    }

    case SettingsViewActionsNames.SET_FOCUSED_COLUMN: {
      const { payload } = action as IActionWithPayload<string, ISetFocusedColumnPayload>;
      return { ...state, focusedColumn: payload.focusedColumn };
    }

    case TEAM.UPDATE_NOTIFICATIONS[RequestAction.REQUEST]: {
      return { ...state, isUpdatingTeamNotifications: true };
    }

    case TEAM.UPDATE_NOTIFICATIONS[RequestAction.SUCCESS]:
    case TEAM.UPDATE_NOTIFICATIONS[RequestAction.FAILURE]: {
      return { ...state, isUpdatingTeamNotifications: false };
    }

    case SettingsViewActionsNames.FETCH_NEXT_FORWARDING_ADDRESS[RequestAction.SUCCESS]: {
      const { payload } = action as IActionWithPayload<string, { name: string }>;

      return { ...state, nextForwardingAddress: payload.name };
    }

    default:
      return state;
  }
}
